import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import "./DeleteProductImage.scss";
import { Button } from '@material-ui/core';

class FindProductImages extends Component {
	constructor(props) {
		super(props);
		this.state = {
			search: '',
			errorSearch: false,
		}
		this.onChange = this.onChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
	}

	onChange(e) {
		e.persist();
		this.setState({
			[e.target.name]: e.target.value,
			errorSearch: e.target.value === "" ? true : false
		});
	}

	onSearch(e) {
		if (this.state.search === "" || this.state.search === null)
			this.setState({
				errorSearch: true
			});
		else
			this.props.GetProductsWithImages(this.state.search, this.props.resolution900x900 ? '900x900' : '300x300');
	}

	componentDidUpdate(prevProps) {
		// console.log(prevProps);
		if ((this.props.resolution900x900 !== prevProps.resolution900x900) && (this.state.search !== "" && this.state.search !== null)) {
			this.onSearch();
		}
	}

	render() {
		return (
			<div style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "flex-start"
			}}>
				<br />
				<h4 style={{ display: "inline" }}>
					Escribe un número sap para mostrarte las imágenes disponibles
				</h4>
				<TextField
					style={{ height: "10%", width: "60%", alignSelf: "center", marginBottom: "4vh" }}
					id="input-search"
					label="NO SAP"
					placeholder="Ej: 400001"
					error={this.state.errorSearch}
					helperText={!this.state.errorSearch ? "" : "El texto es requerido."}
					inputProps={{ style: { fontSize: "1rem", textAlign: "center" } }}
					InputLabelProps={{ style: { fontSize: "0.7rem", textAlign: "center" } }}
					onChange={this.onChange}
					name={"search"}
					value={this.state.search}
					size="medium"
				/>
				<Button
					variant="contained"
					color="primary"
					onClick={this.onSearch}
					style={{
						height: "10%",
						width: "20%",
						alignSelf: "center",
						fontSize: "9px"
					}}
				>
					Buscar
				</Button>
			</div>
		)
	}
}


export default FindProductImages;